<!--
 * @Author: Clark
 * @Date: 2023-02-09 17:03:24
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-02-21 17:44:07
 * @FilePath: \ykc-omp-pro\src\views\merchantCenter\merchantPlatform\ImportData.vue
-->
<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <ykc-form-item class="file-error" label="选择文件" prop="file">
      <ykc-upload
        type="xlsx"
        :size="5"
        ref="file"
        :checkInfo="{ typeMess: '文件格式错误，请重新导入', sizeMess: '文件大小不超过' }"
        @handleRemove="handleRemove"
        @handleChange="fileUpload"
        :temText="linkText"
        :temhref="modelUrl"></ykc-upload>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import { operatorData } from '@/service/apis';

  export default {
    data() {
      return {
        rules: {
          file: [
            {
              required: true,
              trigger: 'change',
              validator: (rule, value, callback) => {
                if (this.$refs.file.fileList.length > 0) {
                  callback();
                } else {
                  callback(new Error('请选择需要导入的文件'));
                }
              },
            },
          ],
        },
        ruleForm: {
          file: undefined,
        },
        formData: null,
      };
    },
    computed: {
      modelUrl() {
        return `${process.env.VUE_APP_OSS}/resource/平台商户导入模板.xlsx`;
      },
      linkText() {
        return '平台商户导入摸板.xlsx';
      },
    },
    created() {},
    methods: {
      fileUpload(file, fileList, isCheck) {
        if (isCheck) {
          this.formData = new FormData();
          const param = {
            file: file.raw,
          };
          Object.entries(param).forEach(([k, v]) => {
            this.formData.append(k, v);
          });
        }
        this.$refs.ruleForm.validateField('file');
      },
      handleRemove() {
        this.ruleForm.file = undefined;
      },
      submitForm() {
        return new Promise(resolve => {
          this.validateForm().then(() => {
            operatorData.importOperator(this.formData).then(res => {
              console.log(JSON.stringify(res));
              this.$message({
                message: '批量导入成功',
                type: 'success',
              });
              resolve();
            });
          });
        });
      },
      /** 校验当前表格是否通过 */
      validateForm() {
        return new Promise(resolve => {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              resolve();
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
